import { Button } from "@/atoms-react/button/Button.react";
import { Modal, ModalContent } from "@/atoms-react/modal/index.react";
import { CardTitle } from "@/atoms-react/text/Text.react";
import { LimitCredentialInterface } from "@/features/auth/types";
import { useState } from "react";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { SolidAuthnModal } from "../../../identity/components/security/solid-authn-modal.react";
import { NewWebauthnDevice } from "./webauthn/NewWebauthnDevice.react";
import { TrDevice } from "./webauthn/TrDevice.react";

type UserDevicesProps = {
  webAuthnUserDevices: LimitCredentialInterface[];
  isWebAuthnActive: boolean | undefined;
  refreshStore: () => Promise<void>;
};
export const UserDevices = ({
  webAuthnUserDevices,
  isWebAuthnActive,
  refreshStore
}: UserDevicesProps) => {
  const { t } = useTranslation(["pass"]);
  const [newDeviceModal, setNewDeviceModal] = useState(false);
  const [addNewWebAuthnDeviceAction, setAddNewWebAuthnDeviceAction] = useState(false);

  const handleAddNewDevice = async () => {
    setAddNewWebAuthnDeviceAction(false);
    setTimeout(() => {
      setNewDeviceModal(true);
    }, 50);
  };
  const handleComplete = async () => {
    setNewDeviceModal(false);
    toast.success(t("olkypass.securityPage.webauthnSection.devices.notifications.add.success"));
    await refreshStore();
  };
  return (
    <>
      {addNewWebAuthnDeviceAction && (
        <SolidAuthnModal
          action="new_webauthn_device"
          onClose={() => setAddNewWebAuthnDeviceAction(false)}
          onValidated={handleAddNewDevice}
        />
      )}
      <Modal open={newDeviceModal} onClose={() => setNewDeviceModal(false)}>
        <ModalContent title={t("olkypass.securityPage.webauthnSection.devices.table.actions.add")}>
          <NewWebauthnDevice onComplete={handleComplete} checkAuthorisation={true} />
        </ModalContent>
      </Modal>
      <div className="mt-4">
        <CardTitle>{t("olkypass.securityPage.webauthnSection.devices.section_title")}</CardTitle>
        {isWebAuthnActive && (
          <Button className="mt-2 max-w-80" onClick={() => setAddNewWebAuthnDeviceAction(true)}>
            {t("olkypass.securityPage.webauthnSection.devices.table.actions.add")}
          </Button>
        )}
      </div>
      <div className="relative mt-4 overflow-x-auto shadow-md sm:rounded-lg">
        <table className="w-full text-left text-gray-500 text-sm rtl:text-right dark:text-gray-400">
          <thead className="bg-gray-50 text-gray-700 text-xs uppercase dark:bg-gray-700 dark:text-gray-400">
            <tr>
              <th scope="col" className="px-6 py-3">
                {t("olkypass.securityPage.webauthnSection.devices.table.columns.device_name")}
              </th>
              <th scope="col" className="px-6 py-3">
                {t("olkypass.securityPage.webauthnSection.devices.table.columns.activation_date")}
              </th>
              <th scope="col" className="px-6 py-3">
                {t("olkypass.securityPage.webauthnSection.devices.table.columns.domain_name")}
              </th>
              <th scope="col" className="px-6 py-3">
                {t("olkypass.securityPage.webauthnSection.devices.table.columns.is_active")}
              </th>
              <th scope="col" className="px-6 py-3">
                <span className="sr-only">Edit</span>
              </th>
            </tr>
          </thead>
          <tbody>
            {webAuthnUserDevices
              ?.slice()
              .sort((a, b) => (a.id < b.id ? 1 : a.id > b.id ? -1 : 0))
              .map((device) => (
                <TrDevice
                  key={device.id + device.active + device.device_name}
                  device={device}
                  onComplete={async () => {
                    toast.success(
                      t(
                        "olkypass.securityPage.webauthnSection.devices.notifications.update.success"
                      )
                    );
                    await refreshStore();
                  }}
                />
              ))}
          </tbody>
        </table>
      </div>
    </>
  );
};
